import { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../utils/authUtils';

export function useAuth() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isUnconfirmed, setIsUnconfirmed] = useState(false);
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

 const checkAuth = useCallback(async () => {
    const token = localStorage.getItem('token');

    if (token) {
      try {
        const response = await api.get('/verify-token');
        setIsAuthenticated(true);
        setUser(response.data.user);
      } catch (error) {
        if (process.env.NODE_ENV === 'development') {
          console.error('Token verification failed:', error);
        }
        localStorage.removeItem('token');
        setIsAuthenticated(false);
        setUser(null);
      }
    } else {
      setIsAuthenticated(false);
      setUser(null);
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);


  const login = async (credentials) => {
  try {
    setLoading(true);
    const response = await api.post('/login', credentials);
    if (response.data.error_code === 'email_not_confirmed') {
      setIsUnconfirmed(true);
      throw { message: response.data.message, error_code: 'email_not_confirmed' };
    }
   localStorage.setItem('token', response.data.access_token);
    await checkAuth();  // Chiama checkAuth dopo aver impostato il token
    navigate('/dashboard');
    return response.data;
  } catch (error) {
    if (error.error_code === 'email_not_confirmed') {
      // Non facciamo nulla qui, lasciamo che il componente gestisca questo caso
      throw error;
    }
    if (process.env.NODE_ENV === 'development') {
      console.error('Login failed:', error);
    }
    throw error;
  } finally {
    setLoading(false);
  }
};

  const register = async (userData) => {
    try {
      setLoading(true);
      const response = await api.post('/register', userData);
      // Non impostare il token o autenticare l'utente immediatamente dopo la registrazione
      return response.data;
    } catch (error) {
      if (process.env.NODE_ENV === 'development') {
        console.error('Registration failed:', error);
      }
      throw error;
    } finally {
      setLoading(false);
    }
  };

  const logout = async () => {
    try {
      await api.post('/logout');
    } catch (error) {
      if (process.env.NODE_ENV === 'development') {
        console.error('Logout API call failed:', error);
      }
    } finally {
      localStorage.removeItem('token');
      setIsAuthenticated(false);
      setUser(null);
      setIsUnconfirmed(false);
      navigate('/login');
    }
  };

  const resendConfirmationEmail = async (email) => {
    try {
      setLoading(true);
      const response = await api.post('/resend-confirmation', { email });
      return response.data;
    } catch (error) {
      if (process.env.NODE_ENV === 'development') {
        console.error('Resend confirmation email failed:', error);
      }
      throw error;
    } finally {
      setLoading(false);
    }
  };

  return { 
    isAuthenticated, 
    isUnconfirmed, 
    loading, 
    user, 
    login, 
    logout, 
    register, 
    checkAuth,
    resendConfirmationEmail
  };
}